export const DS_DEFAULTS = {}

export const DATA_DEFAULTS = {
  designSystem: {},
  components: {},
  integrations: {},
  snippets: {},
  pages: {},
  state: {},
  files: {},
  dependencies: {},
  methods: {},
  functions: {},
  secrets: {}
}

export const SETTINGS_DEFAULTS = {
  remote: false,
  async: false,
  inspect: true,
  liveSync: true,
  syncCanvas: true
}
